import * as THREE from 'three';
import Application from '../Application';
const FIGURINE_HEIGHT = 420;
const DESK_SURFACE_Y = 430;
const FIGURINE_VERTICAL_NUDGE = -850;
const FIGURINE_POSITION_XZ = new THREE.Vector2(1480, 880);
export default class DylanAvatar {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.setModel();
    }
    createUnlitMaterial(material) {
        var _a, _b, _c, _d, _e;
        const source = material;
        const map = source.map || null;
        const alphaMap = source.alphaMap || null;
        if (map) {
            map.encoding = THREE.sRGBEncoding;
            map.needsUpdate = true;
        }
        return new THREE.MeshBasicMaterial({
            map,
            alphaMap,
            color: source.color ? source.color.clone() : new THREE.Color(1, 1, 1),
            transparent: (_a = source.transparent) !== null && _a !== void 0 ? _a : false,
            opacity: (_b = source.opacity) !== null && _b !== void 0 ? _b : 1,
            side: (_c = source.side) !== null && _c !== void 0 ? _c : THREE.FrontSide,
            depthWrite: (_d = source.depthWrite) !== null && _d !== void 0 ? _d : true,
            vertexColors: (_e = source.vertexColors) !== null && _e !== void 0 ? _e : false,
        });
    }
    setModel() {
        this.model = this.resources.items.gltfModel.dylanAvatarModel.scene;
        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                if (Array.isArray(child.material)) {
                    child.material = child.material.map((material) => this.createUnlitMaterial(material));
                }
                else {
                    child.material = this.createUnlitMaterial(child.material);
                }
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        const initialBounds = new THREE.Box3().setFromObject(this.model);
        const initialSize = new THREE.Vector3();
        initialBounds.getSize(initialSize);
        if (initialSize.y > 0) {
            const uniformScale = FIGURINE_HEIGHT / initialSize.y;
            this.model.scale.setScalar(uniformScale);
        }
        // Place avatar as a desk figurine and align feet/base with desk height.
        const scaledBounds = new THREE.Box3().setFromObject(this.model);
        const verticalOffset = DESK_SURFACE_Y - scaledBounds.min.y + FIGURINE_VERTICAL_NUDGE;
        this.model.position.set(FIGURINE_POSITION_XZ.x, verticalOffset, FIGURINE_POSITION_XZ.y);
        this.model.rotation.set(0, -Math.PI * 0.6, 0);
        this.scene.add(this.model);
    }
}
